import { boot } from 'quasar/wrappers'
import jwt_decode from 'jwt-decode'
import { PublicClientApplication } from '@azure/msal-browser'
import { Platform } from 'quasar'

const CLIENTID = 'c01ac03c-0e91-475e-831b-e3f67e91faf5'

const msalStore = {
  namespaced: true,
  state: {
    configMobile: {
      auth: {
        clientId: CLIENTID,
        scopes: ['email', 'User.Read'],
        keyHash: '2jmj7l5rSw0yVb/vlWAYkK/YBwk='
      },
      cache: {
        cacheLocation: 'localStorage'
      }
    },
    configWeb: {
      auth: {
        clientId: CLIENTID,
        authority: 'https://login.microsoftonline.com/organizations',
        redirectUri: process.env.DEV
          ? 'http://localhost:8080/'
          : 'https://reporter.sowellapp.com/',
        postLogoutRedirectUri: process.env.DEV
          ? 'http://localhost:8080/login'
          : 'https://reporter.sowellapp.com/login'
      },
      cache: {
        cacheLocation: 'localStorage'
      }
    },
    accessToken: '',
    idToken: '',
    email: ''
  },
  getters: {
    authMobile: (state) => {
      return JSON.parse(JSON.stringify(state.configMobile.auth))
    },
    authWeb: (state) => {
      return JSON.parse(JSON.stringify(state.configWeb))
    },
    email: (state) => {
      return state.email
    },
    accessToken: (state) => {
      return state.accessToken
    }
  },
  actions: {
    setAccessToken: ({ commit }, token) => {
      commit('ACCESS_TOKEN', token)
    },
    setIdToken: ({ commit }, token) => {
      commit('ID_TOKEN', token)
    },
    setEmail: ({ commit }, email) => {
      commit('EMAIL', email)
    },
    reset: ({ commit }) => {
      commit('ACCESS_TOKEN', '')
      commit('ID_TOKEN', '')
      commit('EMAIL', '')
    }
  },
  mutations: {
    ACCESS_TOKEN(state, token) {
      state.accessToken = token
    },
    ID_TOKEN(state, token) {
      state.idToken = token
    },
    EMAIL(state, email) {
      state.email = email
    }
  }
}

export default boot(async ({ app, store }) => {
  store.registerModule('msal', msalStore)
  const msalInstance = Object.create({})
  const onDevice = Platform.is.capacitor
  const authWeb = store.getters['msal/authWeb']
  const msalWeb = new PublicClientApplication(authWeb)

  msalInstance.mobileSignIn = async () => {
    const authMobile = store.getters['msal/authMobile']
    // NOTE: destructure at the call site — never return the plugin from an async
    // function, its Capacitor proxy would be mistaken for a thenable.
    const { MsAuthPlugin } = onDevice
      ? await import('Capacitor/@recognizebv/capacitor-plugin-msauth')
      : {}

    return new Promise((resolve, reject) => {
      if (onDevice) {
        MsAuthPlugin.login(authMobile).then(
          (result) => {
            handleMsalSuccess(result)
            resolve({
              email: store.getters['msal/email'],
              token: result.accessToken
            })
          },
          (err) => {
            console.error('msal/login Err')
            reject(err)
          }
        )
      } else {
        msalWeb
          .loginPopup({
            scopes: [
              'email',
              'openid',
              'profile',
              'User.Read',
              'offline_access'
            ]
          })
          .then(
            (result) => {
              handleMsalSuccess(result)
              resolve({
                email: store.getters['msal/email'],
                token: result.accessToken
              })
            },
            (err) => {
              console.error('msal/login Err')
              reject(err)
            }
          )
      }
    })
  }

  const handleMsalSuccess = (result) => {
    store.dispatch('msal/setAccessToken', result.accessToken)
    store.dispatch('msal/setIdToken', result.idToken)
    store.dispatch(
      'msal/setEmail',
      jwt_decode(result.idToken).email.toLowerCase()
    )
  }

  msalInstance.signOut = async () => {
    await store.dispatch('msal/reset')
    if (onDevice) {
      const authMobile = store.getters['msal/authMobile']
      const { MsAuthPlugin } = await import(
        'Capacitor/@recognizebv/capacitor-plugin-msauth'
      )
      MsAuthPlugin.logout(authMobile)
    } else {
      msalWeb.logoutPopup()
    }
  }

  app.config.globalProperties.$msal = msalInstance
  app.provide('$msal', msalInstance)
})
